<style>
    .ly-autocomplete-suggestion .el-table  .info-row {
        background: #c9e5f5;
    }
    .ly-autocomplete-suggestion .el-table td,
    .ly-autocomplete-suggestion .el-table th {
        height: 30px;
    }
    .testLyaout {
        background-color: #fff;
    }
</style>
<template>
    <transition name="el-zoom-in-top" @after-leave="doDestroy">
        <div
            v-show="showPopperr"
            class="ly-autocomplete-suggestion"
            :class="{ 'is-loading': parent.loading }"
            :style="{ width: dropdownWidth }">
            <!-- <el-scrollbar
                tag="div"
                wrap-class="el-autocomplete-suggestion__wrap"
                view-class="el-autocomplete-suggestion__list"
                v-if="parent.loading">
                <p style="text-align: center;padding:20px;font-size:16px;">
                    <i class="el-icon-loading"></i>
                </p>
            </el-scrollbar> -->
            <!-- <ly-product-table
                :height="250"
                :suggestions="suggestions"
                :highlightedIndex="highlightedIndex"
                @change="rowClick"
                v-else>
            </ly-product-table> -->
            <ly-table
                :config="dropdownConfig"
                :head="dropdownFields"
                :data="suggestions"
                :highlightedIndex="highlightedIndex"
                @rowClick="rowClick"
                v-loading.body="parent.loading">
            </ly-table>
        </div>
    </transition>
</template>
<script>
    import LyTable from '@c/table'
    import Popper from './vue-popper';
    import Emitter from 'element-ui/src/mixins/emitter'
    // import LyProductTable from '@c/product-table'
    export default {
        mixins: [Popper, Emitter],
        data () {
            return {
                parent: this.$parent,
                dropdownConfig: {
                    height: 250
                } // 结果列表面板的表格配置
            }
        },
        components: {
            LyTable
        },
        props: {
            dropdownFields: Array, // 下拉提示面板所显示的字段配置
            suggestions: Array, // 数据列表
            dropdownWidth: {
                type: String,
                default: '800px'
            },
            showPopperr: Boolean,
            highlightedIndex: Number // 当前高亮的行索引
        },
        methods: {
            /**
             * 一行的数据被点击时
             */
            rowClick (row) {
                this.$emit('change', row)
            }
        },
        updated () {
            this.$nextTick(_ => {
                this.updatePopper();
            })
        },
        mounted () {
            this.popperElm = this.$el;
            this.referenceElm = this.$parent.$refs.input.$refs.input;
        }
    }
</script>